const namespace = 'Users';

export const FETCH_USERS_REQUEST = `${namespace}/FETCH_USERS_REQUEST`;
export const FETCH_USERS_SUCCESS = `${namespace}/FETCH_USERS_SUCCESS`;
export const FETCH_USERS_FAILURE = `${namespace}/FETCH_USERS_FAILURE`;
